// IMPORTANT! if some of these schema will be updated please sync them with json-type-checker/src/Footer/schema.ts

import { Infer, array, object, string } from "superstruct";
import { ModCfIconNames } from "types/cf-utils/types";
import { cfJsonAnchorSchema } from "components/Anchor/schema";

const colSchema = object({
  title: string(),
  list: array(
    object({
      label: string(),
      ...cfJsonAnchorSchema.schema,
    }),
  ),
});

const socialSchema = object({
  title: string(),
  list: array(
    object({
      icon: ModCfIconNames,
      href: string(),
    }),
  ),
});

const topFooterSchema = object({
  left: object({
    apps: object({
      title: string(),
      list: array(
        object({
          image: string(),
          alt: string(),
          href: string(),
        }),
      ),
    }),
  }),
  center: array(colSchema),
  right: object({
    social: socialSchema,
  }),
});

const bottomFooterSchema = object({
  logo: object({
    url: string(),
    src: string(),
    alt: string(),
  }),
  disclaimer: string(),
  manageCookies: string(),
});

const footerSchema = object({
  version: string(),
  top: topFooterSchema,
  bottom: bottomFooterSchema,
});

export type FooterSchema = Infer<typeof footerSchema>;

export type CfFooterSchema = {
  dataJson: FooterSchema;
  identifiers: {
    contentful_id: string;
    __typename: string;
  };
};

export { footerSchema };
